import React from 'react';
import Header from './Header';
import Banner from './Banner';
import Categories from './Categories';

const Hero = ({hide}) => {
  return (
    <div className='hero'>
      <Header hide={hide} />
      {hide&&<Banner />}
      {hide&&<Categories />}
    </div>
  )
}

export default Hero

